// src/components/store/sections/gallery/GalleryV28CarouselstripSunsetAmber.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV28CarouselstripSunsetAmber(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={28}
      archKey="carousel_strip"
      archLabel="Marquee Strip"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
